import TEXT from "../../../utils/globalText";
import ICONS from "../../../assets/Icons";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import DebitCreditAmount from "../../../components/Settings/Statistics/GraphsComponents/DebitCreditAmount";
import IdleFund from "../../../components/Settings/Statistics/GraphsComponents/IdleFund";
import OdInterestSaved from "../../../components/Settings/Statistics/GraphsComponents/OdInterestSaved";
import TransactionCounts from "../../../components/Settings/Statistics/GraphsComponents/TransactionCounts";
import ProductivityTracker from "../../../components/Settings/Statistics/GraphsComponents/ProductivityTracker";
import CashCoveragePeriod from "../../../components/Settings/Statistics/GraphsComponents/CashCoveragePeriod";
import SVGComponent from "../../../components/_utils/SVGComponent";

const Statistics = () => {
  const services = useSelector((state) => state.refreshToken.services);
  const [graphIsOpenInResp, setGraphIsOpenInResp] = useState("");
  const [countOfClicked, setCountOfClicked] = useState(1);
  const [activeIndex, setActiveIndex] = useState(0);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const containerRef = useRef(null);
  const debitCreditRef = useRef(null);
  const idleFundsRef = useRef(null);
  const odInterestRef = useRef(null);
  const txnCountRef = useRef(null);
  const prodTrackerRef = useRef(null);
  const cashCoverageRef = useRef(null);

  const { graphOptions, graphRefs } = useMemo(() => {
    // Commented code for only preprod do not erase this code
    let options = [
      "Debit and credit amount",
      "Idle funds",
      "OD interest saved",
      "Transaction count",
      "Productivity tracker",
      "Cash coverage period",
    ];

    let refs = [
      debitCreditRef,
      idleFundsRef,
      odInterestRef,
      txnCountRef,
      prodTrackerRef,
      cashCoverageRef,
    ];

    // if (
    //   services?.includes("Admin") ||
    //   services?.includes("MimicEntity") ||
    //   services?.includes("BVAccount")
    // ) {
    //   options.push("Beneficiary accounts");
    //   refs.push(beneAccountRef);
    // }

    // if (
    //   services?.includes("Admin") ||
    //   services?.includes("MimicEntity") ||
    //   services?.includes("IVAccount")
    // ) {
    //   options.push("Internal accounts");
    //   refs.push(intAccountRef);
    // }

    // if (services?.includes("Admin") || services?.includes("VAccountBalance")) {
    //   options.push("Beneficiary transactions");
    //   refs.push(beneTxnRef);
    // }

    // if (services?.includes("Admin") || services?.includes("VInternalTxn")) {
    //   options.push("Internal transactions");
    //   refs.push(intTxnRef);
    // }

    return { graphOptions: options, graphRefs: refs };
  }, [services]);

  const handleScrollChange = (direction, containerRef) => {
    if (!containerRef?.current) return;

    const container = containerRef.current;
    const totalCards = graphOptions.length;
    let newIndex = countOfClicked;

    if (direction === "up" && countOfClicked < totalCards) newIndex++;
    else if (direction === "down" && countOfClicked > 1) newIndex--;
    else return;

    const targetRef = graphRefs[newIndex - 1];
    if (targetRef?.current) {
      const targetTop = targetRef.current.offsetTop - container.offsetTop;
      container.scrollTo({ top: targetTop });
    }

    setCountOfClicked(newIndex);
    setGraphIsOpenInResp(graphOptions[newIndex - 1]);
  };

  const graphsObject = graphOptions.map((name, idx) => ({
    name,
    handleFunction: () => {
      const container = containerRef.current;
      const targetCard = graphRefs[idx].current;

      if (container && targetCard) {
        // Compute top position of the card relative to container
        const targetTop = targetCard.offsetTop - container.offsetTop - 20; // 20px space from top

        container.scrollTo({
          top: targetTop,
        });
      }

      // update states
      setGraphIsOpenInResp(name);
      setCountOfClicked(idx + 1);
    },
  }));

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const scrollTop = container.scrollTop;

      // Find the card closest to top
      let closestIndex = 0;
      let minDistance = Infinity;

      graphRefs.forEach((ref, idx) => {
        const cardTop = ref.current.offsetTop - container.offsetTop;
        const distance = Math.abs(scrollTop - cardTop);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = idx;
        }
      });

      // Update only when index actually changes
      setActiveIndex((prev) => {
        if (prev !== closestIndex) {
          setCountOfClicked(closestIndex + 1);
          setGraphIsOpenInResp(graphOptions[closestIndex]);
        }
        return closestIndex;
      });
    };

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [graphOptions, graphRefs]);

  return (
    <div className="min-h-full-height h-height-full w-full-width relative text-text-primary flex flex-col ">
      <div className="h-height-full w-width-full flex flex-col sticky top-top-base z-z-index-tooltip bg-primary-nav">
        <div className="h-navbar-breadcrumb-height Qsmd:block hidden"></div>
        <div className="w-full h-mobile-create-header">
          <div className="max-w-tab-width-normal mx-auto w-full flex Qsmd:flex-row flex-col">
            <div className="Qsmd:max-w-statistic-header-left-section-width Qsmd:w-width-full w-full-width p-padding-md Qsmd:bg-primary-nav-act bg-primary-nav flex items-center gap-gap-sm h-mobile-create-header">
              <img
                className="w-icon-sm h-icon-sm Qsmd:flex hidden"
                src={ICONS?.STATISTICS}
                alt="STATISTICS"
              />
              <div
                className="w-icon-sm h-icon_w-icon-sm Qsmd:hidden flex cursor-pointer"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <SVGComponent
                  url={ICONS?.ARROW_LEFT_WHITE}
                  color={"var(--text-primary)"}
                />
              </div>
              <p className="text-font-md  text-text-primary font-semibold">
                {TEXT?.STATISTICS}
              </p>
            </div>

            <div className="Qsmd:flex hidden items-center">
              <div className="text-text-primary text-font-sm px-padding-xl">
                {TEXT?.STATISTICS_TOP_HEADER_TEXT}
              </div>
            </div>
          </div>
        </div>
        {graphIsOpenInResp ? (
          <div
            className="Qsmd:max-w-statistic-header-left-section-width Qsmd:w-width-full w-full-width p-padding-md bg-primary-nav-act Qsmd:hidden flex items-center gap-gap-sm h-mobile-create-header justify-between z-z-index-tooltip relative"
            onClick={() => {
              setGraphIsOpenInResp("");
            }}
          >
            <p className="text-text-primary text-font-sm">
              {graphIsOpenInResp}
            </p>
            <div className="w-icon-sm h-icon-sm cursor-pointer">
              <SVGComponent
                url={
                  "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                }
                color={"var(--text-primary)"}
                height={"var(--icon-xs)"}
                width={"var(--icon-xs)"}
                alt="Arrow"
              />
            </div>
          </div>
        ) : null}
      </div>
      <div className="flex flex-1 justify-center w-width-full overflow-y-hidden">
        <div className="bg-primary-card flex-1"></div>
        <div className="max-w-tab-width-normal w-width-full flex">
          <div
            className={`Qmd:max-w-statistic-header-left-section-width w-width-full bg-primary-card pl-padding-md overflow-y-auto h-[calc(var(--full-height)-(var(--mobile-navbar-height)+var(--stepper-line-height)))] Qmd:h-[calc(var(--full-height)-(var(--mobile-navbar-height)+var(--navbar-breadcrumb-height)+var(--stepper-line-height)))] fixed ${graphIsOpenInResp !== "" ? "Qsmd:z-z-index-toast z-z-index-base" : "z-z-index-toast"}`}
          >
            {graphsObject?.map((value, index) => {
              return (
                <div>
                  <div
                    className={`flex flex-col ${index ? "mt-margin-top-for-statistics-tab-dot" : ""}`}
                  >
                    <div className="h-height-of-statistics-tab-line w-width-of-statistics-tab-line bg-primary-act"></div>
                    <div className="flex gap-gap-xs items-center ml-margin-left-for-statistics-tab-dot mt-margin-top-for-statistics-tab-dot">
                      <div className="border-border border-primary-nav-act rounded-border-radius-sm p-[var(--border)] h-[max-content] items-center">
                        <div
                          className={`bg-text-secondary rounded-border-radius-sm ${activeIndex === index ? "py-padding-xs px-padding-button-m" : "p-padding-xs"} transition-[width] duration-animation-fast-s ease-in`}
                        ></div>
                      </div>
                      <div>
                        <PrimaryButton
                          btnText={value?.name}
                          enabledBgColor={
                            activeIndex === index
                              ? "var(--primary-nav-act)"
                              : "var(--primary-card)"
                          }
                          enabledTextColor={"var(--text-primary)"}
                          handleFunction={value.handleFunction}
                          hoverOption="white"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="w-width-full max-w-statistic-header-left-section-width h-height-full Qmd:block hidden"></div>

          <div
            className={`relative w-width-full bg-primary-bg flex h-[calc(var(--full-height)-(var(--mobile-navbar-height)+var(--stepper-line-height)))] Qmd:h-[calc(var(--full-height)-(var(--mobile-navbar-height)+var(--navbar-breadcrumb-height)+var(--stepper-line-height)))]`}
          >
            <div className="Qlg:flex hidden bottom-bottom-label-tab absolute z-z-index-content right-right-base flex-col gap-gap-sm">
              <div
                className={`w-icon-md h-icon-md ${countOfClicked <= 1 ? "opacity-light-opacity cursor-not-allowed" : "cursor-pointer"}`}
              >
                <img
                  className="w-icon-md h-icon-md"
                  src={ICONS?.BLUE_ARROW_UP_WHITE_CIRCLE}
                  alt="ArrowUpWhiteCircle"
                  onClick={() => handleScrollChange("down", containerRef)}
                />
              </div>
              <div
                className={`w-icon-md h-icon-md ${countOfClicked >= graphOptions.length ? "opacity-light-opacity cursor-not-allowed" : "cursor-pointer"}`}
              >
                <img
                  className="w-icon-md h-icon-md"
                  src={ICONS?.BLUE_ARROW_DOWN_WHITE_CIRCLE}
                  alt="ArrowDownWhiteCircle"
                  onClick={() => handleScrollChange("up", containerRef)}
                />
              </div>
            </div>
            <div
              ref={containerRef}
              id="main-scrollable-container"
              className=" flex flex-col gap-gap-md w-width-full py-padding-md px-padding-xl absolute h-height-full"
            >
              <div
                className="scroll-card"
                ref={debitCreditRef}
              >
                <DebitCreditAmount />
              </div>
              <div
                className="scroll-card"
                ref={idleFundsRef}
              >
                <IdleFund />
              </div>
              <div
                className="scroll-card"
                ref={odInterestRef}
              >
                <OdInterestSaved />
              </div>
              <div
                className="scroll-card"
                ref={txnCountRef}
              >
                <TransactionCounts autoFetch={false} />
              </div>
              <div
                className="scroll-card"
                ref={prodTrackerRef}
              >
                <ProductivityTracker />
              </div>
              <div
                className="scroll-card"
                ref={cashCoverageRef}
              >
                <CashCoveragePeriod />
              </div>
              {/* Commented for preprod only */}

              {/* <div
                className="scroll-card"
                ref={statementGeneratedRef}
              >
                <StatementGeneratedAndPaymentProcessed
                  flowType={"statementGenerated"}
                />
              </div>

              <div
                className="scroll-card"
                ref={paymentProcessedRef}
              >
                <StatementGeneratedAndPaymentProcessed
                  flowType={"paymentProcessed"}
                />
              </div>
              {services?.includes("Admin") ||
              services?.includes("MimicEntity") ||
              services?.includes("BVAccount") ? (
                <div
                  className="scroll-card"
                  ref={beneAccountRef}
                >
                  <BeneficiaryInternalDetailGraph flowType={"beneAccount"} />
                </div>
              ) : null}

              {services?.includes("Admin") ||
              services?.includes("MimicEntity") ||
              services?.includes("IVAccount") ? (
                <div
                  className="scroll-card"
                  ref={intAccountRef}
                >
                  <BeneficiaryInternalDetailGraph flowType={"intAccount"} />
                </div>
              ) : null}

              {services?.includes("Admin") ||
              services?.includes("VAccountBalance") ? (
                <div
                  className="scroll-card"
                  ref={beneTxnRef}
                >
                  <BeneficiaryInternalDetailGraph flowType={"beneTxn"} />
                </div>
              ) : null}
              {services?.includes("Admin") ||
              services?.includes("VInternalTxn") ? (
                <div
                  className="scroll-card"
                  ref={intTxnRef}
                >
                  <BeneficiaryInternalDetailGraph flowType={"intTxn"} />
                </div>
              ) : null} */}
            </div>
          </div>
        </div>
        <div className="bg-primary-bg flex-1"></div>
      </div>
    </div>
  );
};

export default Statistics;
